import { render, staticRenderFns } from "./SurveyOverview.vue?vue&type=template&id=36129116"
import script from "./SurveyOverview.vue?vue&type=script&lang=js"
export * from "./SurveyOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports